// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#admin-pickups-calendar-v2 {}

#admin-pickups-calendar .occurrence * {
  line-height: 1 !important;
}

#admin-pickups-calendar-v2 .fc .fc-button {
  padding: 0 0;
}

#admin-pickups-calendar-v2 .fc-h-event {
  font-style: normal;
  background-color: transparent;
  border: none;
  font-size: 0.7rem;
  height: auto !important;
  border-bottom: 0px solid #eee;
  border-radius: 0;
}

#admin-pickups-calendar-v2 .fc-h-event .fc-event-main {
  color: black;
}

#admin-pickups-calendar-v2 .fc-daygrid-week-number {
  rotate: 270deg;
  top: 50% !important;
  left: -10px !important;
  line-height: 1px !important;
  padding: 0 !important;
}

#admin-pickups-calendar-v2 .fc .fc-daygrid-day-frame {
  max-height: 35px;
}

#admin-pickups-calendar-v2 .fc-day-today {
  background-color: rgba(255, 232, 80, 0.3);
}

#admin-pickups-calendar-v2 .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {}

#admin-pickups-calendar-v2 .red-circle {
  height: 20px;
  width: 20px;
  margin: 0 auto;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: red;
  border: 1px solid white;
  color: white;
  border-radius: 50%;
}

#admin-pickups-calendar-v2 .fc-day-today .fc-daygrid-day-number {
  font-weight: bold;
  background-color: transparent !important;
}

#admin-pickups-calendar-v2 .fc-toolbar-chunk h2 {
  font-size: 1rem;
}

#admin-pickups-calendar-v2 .fc-event-main {
  text-align: center;
}

#admin-pickups-calendar-v2 .switcher-on .handler {
  background-color: var(--bs-danger);
}

#admin-pickups-calendar-v2 .flow-icon {
  position: relative;
  top: 7px;
  padding-left: 40px;
  /* Ajuste cet espace pour éloigner le texte du rond */
}

#admin-pickups-calendar-v2 .flow-icon::before {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
}

#admin-pickups-calendar-v2 .flow-icon.collecte::before {
  content: "C";
  background-color: #046fb5;
  color: white;
}

#admin-pickups-calendar-v2 .flow-icon.restitution::before {
  content: "R";
  background-color: #899b41;
  color: white;
}

#admin-pickups-calendar-v2 tbody th {
  background-color: #eee;
}

#admin-pickups-calendar-v2 tbody svg {
  position: relative;
  top: -2px;
}

#admin-pickups-calendar-v2 .order-canceled td {
  opacity: 0.4;
  background-color: #eee;
}

#admin-pickups-calendar-v2 .fc-customVersionButton-button {
  background-color: transparent;
  color: #999;
  border: none;
  border-radius: 0;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/pickups/admin/admin-pickups-calendar-v2.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,oFAAoF;;AAEpF;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB","sourcesContent":["#admin-pickups-calendar-v2 {}\r\n\r\n#admin-pickups-calendar .occurrence * {\r\n  line-height: 1 !important;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc .fc-button {\r\n  padding: 0 0;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc-h-event {\r\n  font-style: normal;\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 0.7rem;\r\n  height: auto !important;\r\n  border-bottom: 0px solid #eee;\r\n  border-radius: 0;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc-h-event .fc-event-main {\r\n  color: black;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc-daygrid-week-number {\r\n  rotate: 270deg;\r\n  top: 50% !important;\r\n  left: -10px !important;\r\n  line-height: 1px !important;\r\n  padding: 0 !important;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc .fc-daygrid-day-frame {\r\n  max-height: 35px;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc-day-today {\r\n  background-color: rgba(255, 232, 80, 0.3);\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {}\r\n\r\n#admin-pickups-calendar-v2 .red-circle {\r\n  height: 20px;\r\n  width: 20px;\r\n  margin: 0 auto;\r\n  line-height: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: red;\r\n  border: 1px solid white;\r\n  color: white;\r\n  border-radius: 50%;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc-day-today .fc-daygrid-day-number {\r\n  font-weight: bold;\r\n  background-color: transparent !important;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc-toolbar-chunk h2 {\r\n  font-size: 1rem;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc-event-main {\r\n  text-align: center;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .switcher-on .handler {\r\n  background-color: var(--bs-danger);\r\n}\r\n\r\n#admin-pickups-calendar-v2 .flow-icon {\r\n  position: relative;\r\n  top: 7px;\r\n  padding-left: 40px;\r\n  /* Ajuste cet espace pour éloigner le texte du rond */\r\n}\r\n\r\n#admin-pickups-calendar-v2 .flow-icon::before {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0;\r\n  transform: translateY(-50%);\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-weight: bold;\r\n  font-size: 12px;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .flow-icon.collecte::before {\r\n  content: \"C\";\r\n  background-color: #046fb5;\r\n  color: white;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .flow-icon.restitution::before {\r\n  content: \"R\";\r\n  background-color: #899b41;\r\n  color: white;\r\n}\r\n\r\n#admin-pickups-calendar-v2 tbody th {\r\n  background-color: #eee;\r\n}\r\n\r\n#admin-pickups-calendar-v2 tbody svg {\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .order-canceled td {\r\n  opacity: 0.4;\r\n  background-color: #eee;\r\n}\r\n\r\n#admin-pickups-calendar-v2 .fc-customVersionButton-button {\r\n  background-color: transparent;\r\n  color: #999;\r\n  border: none;\r\n  border-radius: 0;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
